export class ObrigacaoAplicacaoVO {

  obrigacaoInstituicao:number;
  convenioRegiaoInfluencia:number;
  instituicaoPublica:number;
  instituicaoPrivada:number;
  instituicaoOutraRegiao:number;
  remanescentePdi:number;
  fndctDeposito:number;
  trocaPpbPdi:number;
  aplicacaoPdi:number;

  obrigacaoInstituicaoPadis: number;
  faturamentoContraPartida: number;
  remanescentePdiPadis: number;
  aplicacaoPdiPadis: number;


}
